/* eslint-disable no-nested-ternary */

import React, { useState } from 'react'

import { ChevronLeft, ChevronRight } from 'emotion-icons/material'
import { HEADER } from '../../utils/dataTrackingValues'
import Typography from '../Typography'
import * as Styled from './Header.styles'

const MobileNav = ({ dark = false, navData, CustomLink = null, ...props }) => (
  <Styled.MobileNav dark={dark} className="leshen-mobilenav" {...props}>
    <List CustomLink={CustomLink} items={navData} className="list" />
  </Styled.MobileNav>
)

// A List has ListItems, and ListItems may have Lists in themselves.
const List = ({
  parent = null,
  items,
  setSubOpen = null,
  CustomLink = null,
}) => (
  <div>
    <ul>
      {/* If this List has received a setSubOpen function, it is a child of
          a ListItem and a Back button will be rendered. */}
      {setSubOpen && (
        <button
          data-testid="mobile-menu-back-button"
          type="button"
          className="back-button"
          onClick={() => {
            setSubOpen(false)
          }}
        >
          <ChevronLeft />
          <Typography rendersAs="span">Back</Typography>
        </button>
      )}
      <>
        {parent && (
          <ListItem CustomLink={CustomLink} key={parent.text} item={parent} />
        )}
        {items?.map((item) => (
          <ListItem CustomLink={CustomLink} key={item.text} item={item} />
        ))}
      </>
    </ul>
  </div>
)

// The ListItem component is called from a List and may have a List as a child.
// The ListItem holds the state of whether its child List is open or not, and
// the child List controls when to close itself.
function ListItem({ item, CustomLink = null }) {
  const nav = item?.megaLinks || item?.subnav
  const [subOpen, setSubOpen] = useState(false)
  return (
    <li>
      {nav ? (
        <>
          <button
            data-tracking={HEADER.MOBILE_NAVIGATION_ITEM}
            type="button"
            onClick={() => setSubOpen(!subOpen)}
          >
            <Typography rendersAs="span">{item.text}</Typography>
            <ChevronRight />
          </button>
          {subOpen && (
            <List
              parent={{ text: item.text, href: item?.link || item.href }}
              items={item?.megaLinks || item.subnav}
              setSubOpen={setSubOpen}
              CustomLink={CustomLink}
            />
          )}
        </>
      ) : CustomLink ? (
        <CustomLink
          to={item?.link || item.href}
          data-tracking={HEADER.MOBILE_NAVIGATION_ITEM}
          // eslint-disable-next-line prettier/prettier
          onClick={() => HEADER.LINKS.handleClick(item.text, item?.link || item.href)}
        >
          {item.text}
        </CustomLink>
      ) : (
        <a href={item?.link || item.href}>{item.text}</a>
      )}
    </li>
  )
}

export default MobileNav
